import { render } from "./Error403.vue?vue&type=template&id=01a0a46f"
import script from "./Error403.vue?vue&type=script&lang=js"
export * from "./Error403.vue?vue&type=script&lang=js"

import exportComponent from "/home/nginx/domains/tools.androidrepublic.org/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Error403.vue"]])

export default __exports__